module.exports = __webpack_public_path__ + "img/02.766cc8aa.png";